import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countryName',
  pure: true
})
export class CountryNamePipe implements PipeTransform {

  transform(countryCode: string, lang: string) {
    if (!countryCode) return '';
    try {
      const regionNames = new Intl.DisplayNames([lang], { type: 'region' });
      return regionNames.of(countryCode.toUpperCase()) || countryCode;
    } catch (error) {
      console.error('Invalid language or country code:', error);
      return countryCode;
    }
  }

}
